export default __webpack_public_path__ + "assets/images/9985db6e68c7e6a93063db6b0fbd8313.png";